import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { EstimatedValues } from '@shared/models/Reporting';
import { CustomerInvestmentData } from '@shared/models/Strategy';

@Component({
  selector: 'app-savings-sum-up',
  styleUrls: ['./savings-sum-up.component.scss'],
  templateUrl: './savings-sum-up.component.html',
  standalone: false
})
export class SavingsSumUpComponent implements OnChanges {
  @Input() customerInvestment: CustomerInvestmentData;
  @Input() currentChip: number;
  @Input() estimatedPeriod: number;
  @Input() estimatedValues: EstimatedValues;
  @Input() kind: string;
  @Input() language: string;
  @Input() newMonthlyValue: number;

  riskLevel: string;
  totalDeposit: number;

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.customerInvestment) {
      const investment = changes.customerInvestment.currentValue as CustomerInvestmentData;
      this.riskLevel = this.getRiskName(investment.stock_split);
    }

    if (changes?.customerInvestment || changes?.newMonthlyValue || changes?.estimatedPeriod || changes?.currentChip) {
      this.totalDeposit = this.getTotalDeposit();
    }
  }

  getRiskName(split: number): string {
    switch (true) {
      case split > 0.8:
        return 'very_dynamic';
      case split > 0.6:
        return 'dynamic';
      case split > 0.4:
        return 'balanced';
      case split > 0.2:
        return 'conservative';
      case split >= 0:
        return 'very_conservative';
      default:
        return 'balanced';
    }
  }

  getTotalDeposit() {
    const { total } = this.customerInvestment;
    if (this.currentChip === 1 && this.kind !== '3a') {
      return total;
    }
    const multiplier = this.kind === '3a' && this.currentChip !== 0 ? 1 : 12;
    const reinvested = this.newMonthlyValue * multiplier * this.estimatedPeriod;
    return total + reinvested;
  }
}
